import { mapHero } from '@websrc/DataMappers/mapHero'
import React from 'react'
import { match } from 'ts-pattern'

import { PageHero } from '../Hero/PageHero/PageHero'
import { CoralPageHero } from './CoralPageHero/CoralPageHero'

export interface HeroProps {
  hero: ReturnType<typeof mapHero>
}

export const Hero = ({ hero }: HeroProps) =>
  match(hero)
    .with({ __dataType: 'pageHero' }, (pageHero) => <PageHero {...pageHero} />)
    .with({ __dataType: 'coralWebHero' }, (coralPageHero) => <CoralPageHero {...coralPageHero} />)
    // exhaustive should work here but doesn't because of unexpected data coming from contentstack
    .otherwise(() => null)
